import * as React from "react"

// These are the default values for the properties as found on the
// browser's SVG element:
export const svgElementAttributeDefaults: React.SVGAttributes<SVGElement> = {
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "0",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    fill: "black",
    fillRule: "nonzero",
    fillOpacity: 1,
}
